import React, { useEffect } from 'react';
import { I18nextProvider, useTranslation } from 'react-i18next';
import { initI18n, persistLocale, i18n } from './config';
import { applyDocumentDirection } from './rtl';
import { setApiLanguage } from './apiLanguage';

initI18n();

function RtlSync({ children }) {
  const { i18n: i18nInstance } = useTranslation();

  useEffect(() => {
    const sync = (lng) => {
      applyDocumentDirection(lng);
      setApiLanguage(lng);
      persistLocale(lng);
    };
    sync(i18nInstance.language);
    i18nInstance.on('languageChanged', sync);
    return () => i18nInstance.off('languageChanged', sync);
  }, [i18nInstance]);

  return children;
}

export default function I18nProvider({ children }) {
  return (
    <I18nextProvider i18n={i18n}>
      <RtlSync>{children}</RtlSync>
    </I18nextProvider>
  );
}
